export const failureHash = {
    INVITE_ALREADY_CONFIRMED: "API__EP__ORGANIZATION__INVITE_ALREADY_CONFIRMED",
    INVITE_CANCELLED: "API__EP__ORGANIZATION__INVITE_CANCELLED",
    INVITE_CODE_INVALID: "API__EP__ORGANIZATION__INVITE_CODE_INVALID",
    INVITE_CODE_OUT_OF_DATE: "API__EP__ORGANIZATION__INVITE_CODE_OUT_OF_DATE",
    INVITE_USER_MISMATCH: "API__EP__ORGANIZATION__INVITE_USER_MISMATCH",
    ORGANIZATION_ID_INVALID: "API__EP__ORGANIZATION__ORGANIZATION_ID_INVALID",
    ORGANIZATION_LIMIT_HIT: "API__EP__ORGANIZATION__ORGANIZATION_LIMIT_HIT",
    ORGANIZATION_MEMBERSHIP_LIMIT_HIT: "API__EP__ORGANIZATION__ORGANIZATION_MEMBERSHIP_LIMIT_HIT",
    ORGANIZATION_NAME_ALREADY_EXISTS: "API__EP__ORGANIZATION__ORGANIZATION_NAME_ALREADY_EXISTS",
    ORGANIZATION_NOT_EMPTY: "API__EP__ORGANIZATION__ORGANIZATION_NOT_EMPTY",
    ORGANIZATION_NOT_FOUND: "API__EP__ORGANIZATION__ORGANIZATION_NOT_FOUND",
    ORGANIZATION_TEMPORARILY_INACTIVE: "API__EP__ORGANIZATION__ORGANIZATION_TEMPORARILY_INACTIVE",
    SELF_INVITE_FORBIDDEN: "API__EP__ORGANIZATION__SELF_INVITE_FORBIDDEN",
    USER_EMAIL_NOT_VERIFIED: "API__EP__ORGANIZATION__USER_EMAIL_NOT_VERIFIED", // Only verified users can be invited to a team.
};
//# sourceMappingURL=organization.static.js.map